// extracted by mini-css-extract-plugin
export default {"title":"Events_title__MAXjF","events":"Events_events__pI5RN","buttonWrapper":"Events_buttonWrapper__6BBSc"};